define('modules/lists/modals/views/create.company.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    'select2',
    'modules/lists/modals/views/edit.contact.view',
    'modules/base/models/user.identity.model',
    "text!modules/lists/modals/templates/create.company.template.html"
], function(
    Prospector,
    $, _,Backbone, Select2,
    EditContactView,
    UserIdentityModel,
    Template
){
    var CreateCompanyView = EditContactView.extend({
        template: _.template(Template),
        initialize: function(options) {
            this.data = options;
            EditContactView.prototype.initialize.call(this, options);
            this.minimumList = 1;
        },
        buildModel:function(){
        },
        procMainBtn:function(e){
            var lists = this.$('.ui.dropdown').dropdown('get values');
            var company = this.$('#companyCC').val();
            var headline = this.$('#headlineCC').val();
            if(lists == undefined || lists.length < this.minimumList){
                this.removeMainBtnLoader();
                this.errOut('You must enter at least one list.');
            } else if(company.trim() == ""){
                this.removeMainBtnLoader();
                this.errOut('Company cannot be blank.');
            } else if(window.entitlements.get('settings').allowSetContactType
                && this.$('.contactType .btn-default.active input').prop('value') == undefined) {
                this.removeMainBtnLoader();
                this.errOut('Please select a contact type.');
            } else {
                this.identityModel = new UserIdentityModel();
                this.passedNumListCheck();
            }
        },
        configModel:function(e){
            if(window.entitlements.get('settings').allowSetContactType){
                var stuff = this.$('.contactType .btn-default.active input');
                switch(stuff.prop('value').toLowerCase()){
                    case 'client':{
                        this.identityModel.set({
                            contactType: 'client'
                        });
                        break;
                    }
                    case 'prospect':{
                        this.identityModel.set({
                            contactType: 'prospect'
                        });
                        break;
                    }
                    default:{
                        this.identityModel.set({
                            contactType: 'lead'
                        });
                        break;
                    }
                }
            } else {
                this.identityModel.set({
                    contactType: 'contact'
                });
            }
            var company = this.$('#companyCC').val().trim();
            var headline = this.$('#headlineCC').val().trim();
            this.identityModel.set(
                {
                    name: company,
                    headline: headline,
                    identityType: 'organization',
                    isInCRM: false,
                    isSharedContact: false,
                    source:{
                        sourceId: 2000
                    }
                }
            );
            this.createLists();
        },
        procMainBtnResponse:function(){
            this.closeModal();
            Prospector.navigate('profile/organization/1/' + this.identityModel.get('id'), true);
        },
        onRender:function(){
            this.$('.modal-title').html('Create Company');
            this.$('.mainBtn').css('display', 'inline-block');
            this.$(this.mainBtnLoaderTextSelector).html(this.mainBtnLoaderRestingText);
            if(this.data.state){
                this.$('#companyCC').val(this.data.company);
            } else {
                this.$('#companyCC').val(this.data.main);
            }
            if(window.entitlements.get('settings').allowSetContactType){
                this.$('.hasContactTypePriv').show();
            } else {
                this.$('.hasContactTypePriv').remove();
            }
            _.each(window.utils.getInternalLists(), function(list){
                this.$('.ui.dropdown .menu').append('<div class="item" data-source="1" data-value="' + list.source.refId+ '">' +list.name+ '</div>');
            }, this);

            var that = this;
            this.$('.ui.dropdown').dropdown({
                allowAdditions: true,
                fullTextSearch: true,
                forceSelection: false,
                onHide:function(){
                    $(that.$('.ui.dropdown input')[1]).val("");
                }
            });
        }
    });
    return CreateCompanyView;
});
